export default {
  legacy: false,
  globalInjection: true,
  runtimeOnly: false,
};
